import type { ScreenType } from '../../types';

export type OnMarsSectionSource =
  | 'fullManual'
  | 'firstGame'
  | 'quickReference'
  | 'guidedTutorial'
  | 'faq'
  | 'reference'
  | 'mistakes'
  | 'scoring';

export type OnMarsSectionMeta = {
  id: string;
  title: string;
  source: OnMarsSectionSource;
  /** ScreenType used by App.tsx */
  screen: ScreenType;
  /** Chapter index, FAQ id, reference id, guided step id, etc. */
  targetId: string;
  relatedSectionIds?: string[];
  keywords?: string[];
};

export type OnMarsNavTarget = {
  screen: ScreenType;
  chapterIndex?: number;
  faqId?: string;
  referenceId?: string;
  guidedStepId?: string;
  firstGameStepIndex?: number;
  quickRefId?: string;
};

export const ON_MARS_SOURCE_LABEL: Record<OnMarsSectionSource, string> = {
  fullManual: 'Pełna instrukcja',
  firstGame: 'Pierwsza gra',
  quickReference: 'Szybka pomoc',
  guidedTutorial: 'Samouczek',
  faq: 'FAQ',
  reference: 'Słownik',
  mistakes: 'Najczęstsze błędy',
  scoring: 'Punktowanie',
};

export const ON_MARS_CHAPTER_TITLES = [
  'Cel gry',
  'Najważniejsze pojęcia',
  'Elementy gry',
  'Przygotowanie dla 3 graczy',
  'Przygotowanie dla 4 graczy',
  'Układ planszy',
  'Obieg zasobów',
  'Kryształy i magazyn',
  'Koloniści',
  'Boty',
  'Łaziki',
  'Statki',
  'Technologia',
  'Budynki i kompleksy',
  'Poziom kolonii LSS',
  'Misje',
  'Cele prywatne',
  'Kontrakty',
  'Kolejność tury',
  'Pobyt na orbicie',
  'Podróż na powierzchnię',
  'Pobyt na powierzchni',
  'Podróż na orbitę',
  'Akcje główne na orbicie',
  'Pozyskanie planu',
  'Nauka nowej technologii',
  'Uzupełnianie magazynu',
  'Akcje główne na powierzchni',
  'Budowa budynku',
  'Ulepszenie budynku',
  'Przyjęcie statku',
  'Zatrudnianie naukowców i kontrakty',
  'Akcje wykonawcze',
  'Ruch łazika',
  'Korzystanie z technologii innych graczy',
  'Rozwój LSS',
  'Postęp misji',
  'Koniec rundy',
  'Koniec gry',
  'Punktacja końcowa',
  'Remisy',
  'Najczęstsze błędy',
  'Księga odniesienia i FAQ',
  'Pełny skrót tury',
] as const;

export function fmId(chapterIndex: number): string {
  return `fm:${chapterIndex}`;
}

export function faqId(id: string): string {
  return `faq:${id}`;
}

export function refId(id: string): string {
  return `ref:${id}`;
}

export function fgId(stepId: number): string {
  return `fg:${stepId}`;
}

export function qrId(id: string): string {
  return `qr:${id}`;
}

export function gtId(stepId: string): string {
  return `gt:${stepId}`;
}

export function errId(id: string): string {
  return `err:${id}`;
}

export function sectionToNavTarget(section: OnMarsSectionMeta): OnMarsNavTarget {
  switch (section.source) {
    case 'fullManual':
      return {
        screen: 'fullManual',
        chapterIndex: Number(section.targetId),
      };
    case 'firstGame':
      return {
        screen: 'firstGame',
        firstGameStepIndex: Number(section.targetId),
      };
    case 'quickReference':
      return {
        screen: 'quickReference',
        quickRefId: section.targetId,
      };
    case 'guidedTutorial':
      return {
        screen: 'onMarsGuided',
        guidedStepId: section.targetId,
      };
    case 'faq':
      return {
        screen: 'onMarsFaq',
        faqId: section.targetId,
      };
    case 'reference':
      return {
        screen: 'onMarsReference',
        referenceId: section.targetId,
      };
    case 'mistakes':
      return {
        screen: 'onMarsMistakes',
        referenceId: section.targetId,
      };
    case 'scoring':
      return {
        screen: 'onMarsScoring',
      };
  }
}
